<ng-container *transloco="let t">
  <mat-toolbar class="app-header">

    @if (variant() === 'home') {
      <span class="app-header__title">{{ t('header.homeTitle') }}</span>
    }

    @if (variant() === 'stepper') {
      <mat-toolbar-row class="app-header__row">
        <button
          mat-icon-button
          class="app-header__back"
          (click)="goBack()"
          [attr.aria-label]="t('header.backAriaLabel')"
        >
          <fa-icon [icon]="faArrowLeft" aria-hidden="true"></fa-icon>
        </button>
        <span class="app-header__title">
          {{ t('header.stepLabel', { current: formService.currentStep(), total: formService.totalSteps }) }}
        </span>
      </mat-toolbar-row>
      <mat-toolbar-row class="app-header__progress-row">
        <mat-progress-bar
          class="app-header__progress"
          mode="determinate"
          [value]="progressPercent()"
          [attr.aria-label]="t('header.stepLabel', { current: formService.currentStep(), total: formService.totalSteps })"
        />
      </mat-toolbar-row>
    }

    @if (variant() === 'detail') {
      <button
        mat-icon-button
        class="app-header__back"
        (click)="goBack()"
        [attr.aria-label]="t('header.backAriaLabel')"
      >
        <fa-icon [icon]="faArrowLeft" aria-hidden="true"></fa-icon>
      </button>
      <span class="app-header__title">{{ t('header.detailTitle') }}</span>
    }

    @if (variant() === 'cancel') {
      <button
        mat-icon-button
        class="app-header__back"
        (click)="goBack()"
        [attr.aria-label]="t('header.backAriaLabel')"
      >
        <fa-icon [icon]="faArrowLeft" aria-hidden="true"></fa-icon>
      </button>
      <span class="app-header__title">{{ t('header.cancelTitle') }}</span>
    }

    @if (variant() === 'list') {
      <button
        mat-icon-button
        class="app-header__back"
        (click)="goBack()"
        [attr.aria-label]="t('header.backAriaLabel')"
      >
        <fa-icon [icon]="faArrowLeft" aria-hidden="true"></fa-icon>
      </button>
      <span class="app-header__title">{{ t('header.myRequestsTitle') }}</span>
    }

  </mat-toolbar>
</ng-container>
